<template>
  <b-row class="h-100">
    <b-colxx sm="12" md="5" class="mx-auto my-auto">
      <img class="align-self-center" style="padding: 20px;" src="/assets/img/hitable_logo.png">
      <b-card>
        <div class="form-side">
          <h2 class="mb-4" >HI-TABLE은 <img src="/assets/img/chrome.png" style="width: 25px;">크롬(Chrome)에서 최적화 되어있습니다.</h2>
          <h3 class="mb-4" style="color:red">현재 고객님이 사용하고 계신 브라우저는 인터넷 익스플로러 입니다.<br>
          </h3>
          <div style="height: auto; width: 100%; border:1px solid black;">
            <br>
            <h4 class="mb-4" >&nbsp;&nbsp;&nbsp;※ 크롬 (Chrome)이 없는 경우 설치해 주시기 바랍니다.<a href="https://www.google.com/chrome/" style="color: rgb(051, 051, 255);"> [다운받기]</a><br>
              &nbsp;&nbsp;&nbsp;※ 인터넷 익스플로러 (Internet Explorer) 는 지원되지 않습니다.</h4>
          </div>
          </div>
      </b-card>
    </b-colxx>
  </b-row>
</template>

<script>
export default {
  name: "IpError",
  methods: {
  },
  mounted: function () {
    document.body.classList.add("background");
  },
  beforeDestroy() {
    document.body.classList.remove("background");
  }
}
</script>

<style scoped>

</style>
